import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { JobCard } from './JobCard';
export function JobList({ jobs, config }) {
    // jobs_columns: 1/2/3 oszlop a hirdetéslistában (admin select); default 3 ha nincs beállítva
    const cols = config.ui_config?.jobs_columns || 3;
    let gridCols;
    if (cols === 1) {
        gridCols = 'grid-cols-1';
    }
    else if (cols === 2) {
        gridCols = 'grid-cols-1 md:grid-cols-2';
    }
    else {
        gridCols = 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
    }
    return (_jsx("div", { className: `career-jobs-list grid gap-6 ${gridCols}`, children: jobs.map(j => _jsx(JobCard, { job: j, config: config }, j.id)) }));
}
